import { render, staticRenderFns } from "./moduleList.vue?vue&type=template&id=df37986c&"
import script from "./moduleList.vue?vue&type=script&lang=js&"
export * from "./moduleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports